export enum MetricBarType {
  TwoZone = 'two-zone',
  ThreeZone = 'three-zone'
}
